import api from './api';
import { PracticeRecord, NextSentenceInfo } from '../types';

/**
 * 开始练习，创建练习记录
 */
export async function startPractice(params: {
  sentence_id?: string;
  unit_id?: string;
  sentence_text: string;
}): Promise<{ practice_id: string; started_at: string }> {
  const response = await api.post('api/practice/start', params);
  return response.data;
}

/**
 * 保存单步练习记录
 */
export async function saveStepRecord(
  practiceId: string,
  params: {
    step_num: number;
    score: number;
    attempts: number;
    duration_seconds: number;
    ai_feedback?: string;
  }
): Promise<{ success: boolean; message: string }> {
  const response = await api.post(`api/practice/${practiceId}/step`, params);
  return response.data;
}

/**
 * 完成练习
 */
export async function completePractice(
  practiceId: string,
  totalScore: number
): Promise<{ success: boolean; message: string; completed_at: string }> {
  const response = await api.post(`api/practice/${practiceId}/complete`, {
    total_score: totalScore,
  });
  return response.data;
}

/**
 * 获取练习详情
 */
export async function getPracticeDetail(practiceId: string): Promise<PracticeRecord> {
  const response = await api.get(`api/practice/${practiceId}`);
  return response.data;
}

/**
 * 获取单元内的下一个句子
 */
export async function getNextSentence(
  unitId: string,
  currentSentenceId: string
): Promise<NextSentenceInfo> {
  const response = await api.get(`api/units/${unitId}/next-sentence`, {
    params: { current_sentence_id: currentSentenceId },
  });
  return response.data;
}

